import { render } from "./ProfilePanelNavigation.vue?vue&type=template&id=a5830006&scoped=true"
import script from "./ProfilePanelNavigation.vue?vue&type=script&lang=js"
export * from "./ProfilePanelNavigation.vue?vue&type=script&lang=js"

import "./ProfilePanelNavigation.vue?vue&type=style&index=0&id=a5830006&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5830006"]])

export default __exports__